import React from 'react';
import PropTypes from 'prop-types';

const Disclaimer = ({ disclaimers }) => {
  if (!disclaimers.length) return null;
  return (
    <div>
      {disclaimers.map((disclaimer, i) => (
        <div className="appdetailpage-disclaimer" key={`disclaimer-${i}`}>
          <span className="disclaimer-asterisk">{'*'.repeat(i + 1)}</span>
          <span dangerouslySetInnerHTML={{ __html: disclaimer }} />
        </div>
      ))}
    </div>
  );
};

Disclaimer.propTypes = {
  disclaimers: PropTypes.array
};

export default Disclaimer;
